"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { tbShowFilterModalClicked } from "Actions/Table/TableToolBarActions";
import { Messages } from "Messages";
import { System } from "Constants/objects";

var ShowModalFilterButtonProp =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(ShowModalFilterButtonProp, _BaseToolbarButtonPro);

  function ShowModalFilterButtonProp(_ref) {
    var _this;

    var formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        title = _ref.title,
        rest = _objectWithoutProperties(_ref, ["formUUID", "isContextMenu", "title"]);

    _classCallCheck(this, ShowModalFilterButtonProp);

    var props = _objectSpread({
      isContextMenu: isContextMenu,
      text: title || Messages.Controls.Filter,
      hint: title || Messages.Controls.Filter,
      elementAttr: {
        'class': System.TOOLBAR_BTN_CLASSES.SEARCH
      },
      onClick: function onClick(e) {
        _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
        tbShowFilterModalClicked({
          formUUID: _this.UUID
        });
      }
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShowModalFilterButtonProp).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;

    _this.setOptions({
      iconType: _this.getOptions().iconType || 'fontawesome:fas fa-search'
    });

    return _this;
  }

  return ShowModalFilterButtonProp;
}(BaseToolbarButtonProp);

_defineProperty(ShowModalFilterButtonProp, "create", function (options) {
  return new ShowModalFilterButtonProp(options).props();
});

export { ShowModalFilterButtonProp as default };